import { render } from "./ReturnItem.vue?vue&type=template&id=6cfb2be0&scoped=true"
import script from "./ReturnItem.vue?vue&type=script&lang=js"
export * from "./ReturnItem.vue?vue&type=script&lang=js"

import "./ReturnItem.vue?vue&type=style&index=0&id=6cfb2be0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfb2be0"]])

export default __exports__